module.exports = __webpack_public_path__ + "img/oval.c3079d1f.svg";